var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-box main-box"},[_c('div',{staticClass:"area-tree"},[_c('div',{staticClass:"tree-box"},[_c('div',{staticClass:"tree-header",on:{"click":_vm.clickTop}},[_vm._v("\n        组织机构\n      ")]),_vm._v(" "),_c('div',{staticClass:"zTreeDemoBackground left"},[_c('ul',{staticClass:"ztree",attrs:{"id":_vm.treeId}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01d02d12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/sys/org/org-tree.vue
// module id = null
// module chunks = 